module.exports = __webpack_public_path__ + "img/B2.65a65b71.png";